import { cn } from '@poseidon/components/cn';
import { type ComponentProps, useEffect, useState } from 'react';

export type NotificationLabelProps = ComponentProps<'div'> & {
  counterValue: number;
  gradient?: boolean;
};
const NotificationLabel = ({ className, counterValue, gradient }: NotificationLabelProps) => {
  const [isShaking, setIsShaking] = useState(false);

  useEffect(() => {
    if (counterValue !== 0) {
      setIsShaking(true);
      setTimeout(() => {
        setIsShaking(false);
      }, 1000);
    }
  }, [counterValue]);

  if (counterValue <= 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'min-w-5 absolute right-2 top-1/2 flex -translate-y-1/2 items-center justify-center rounded-full px-1.5 py-1 text-xs font-bold leading-none text-white',
        gradient ? 'bg-indigo-500' : 'bg-red-600',
        { 'animate-shakeX': isShaking },
        className,
      )}>
      {counterValue > 99 ? '99+' : counterValue}
    </div>
  );
};

export default NotificationLabel;
